// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__24qEH","tab":"Tabs_tab__RC1JT","tabActive":"Tabs_tabActive__3gYLF"};